<template>
  <div class="ips_history">

    <TextTable
      :all_data = "all_data"
    />

  </div>
</template>

<script>

import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';

export default {
  name: 'IpsHistory',
  components: {
    TextTable
  },
  props: {
    request: {
      type: String,
      default: 'all'
    }
  },

  data () {
    return {
      load: true,
      all_data: {}
    }
  },

  created () {
    this.get_history()
  },

  methods: {
    get_history(){
      this.$http.v1.getAddressesHistory((response) => {
        this.all_data = response.data
      })
    }
  },
}
</script>
<style lang='scss' scoped>
  .ips_history{
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
 </style>
